// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import SafeComponent from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import { styleOverrideEngine, getModuleModClassSpacing } from '@tcp/core/src/utils';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import getMediaBorderRadiusOverride from '../utils/ModuleTabbedCarousel.utils';
import HeaderText from '../molecules/HeaderText';
import LinkedImage from '../molecules/LinkedImage';
import CarouselTab from '../molecules/CarouselTab';
import { StyledContainer, StyledSkeleton } from '../styles/ModuleTabbedCarousel.style';

const ModuleTabbedCarousel = (props) => {
  const {
    isHpNewModuleDesignEnabled,
    moduleClassName,
    layout,
    bgClass,
    bgColor,
    headerText,
    carouselTabs,
    categoriesList,
    isHomePage,
    icidParam,
    variation,
    linkedImage,
    disableVideosForAppleDevice,
    moduleAnalyticsTag,
  } = props;
  const hasMounted = useHasMounted();
  const { extraConfig } = React.useContext(LabelsContext);
  const { isDamImageV2Enabled } = extraConfig || {};

  const styleOverrides =
    !isEmpty(bgColor) && isHpNewModuleDesignEnabled && !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleTabbedCarousel')
      : {};
  const mediaBorderRadiusOverride = !isEmpty(styleOverrides)
    ? getMediaBorderRadiusOverride(styleOverrides)
    : {};
  const { marginTop = {}, marginBottom = {} } = getModuleModClassSpacing(styleOverrides);

  return (
    <StyledContainer
      className={`layout-${layout} ${moduleClassName} module-tabbed-carousel ${bgClass}`}
      backgroundColor={bgColor}
      style={mediaBorderRadiusOverride}
      spacingTop={marginTop}
      spacingBottom={marginBottom}
    >
      {!isEmpty(headerText) ? <HeaderText headerText={headerText} layout={layout} /> : <></>}
      {!isEmpty(linkedImage) ? (
        <LinkedImage
          linkedImage={linkedImage[0]}
          isHomePage={isHomePage}
          disableVideosForAppleDevice={disableVideosForAppleDevice}
          moduleAnalyticsTag={moduleAnalyticsTag}
        />
      ) : (
        <></>
      )}
      {hasMounted && (!isEmpty(carouselTabs) || !isEmpty(categoriesList)) ? (
        <CarouselTab
          carouselTabs={carouselTabs}
          categoriesList={categoriesList}
          isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
          windowSize={[window?.innerWidth]}
          bgColor={bgColor}
          isHomePage={isHomePage}
          isDamImageV2Enabled={isDamImageV2Enabled}
          icidParam={icidParam}
          variation={variation}
          moduleAnalyticsTag={moduleAnalyticsTag}
        />
      ) : (
        <StyledSkeleton col={6} colSize={{ small: 2, medium: 2, large: 2 }} removeLastMargin />
      )}
    </StyledContainer>
  );
};

ModuleTabbedCarousel.propTypes = {
  isHpNewModuleDesignEnabled: PropTypes.bool,
  layout: PropTypes.string.isRequired,
  headerText: PropTypes.arrayOf(PropTypes.shape({})),
  carouselTabs: PropTypes.arrayOf(PropTypes.shape({})),
  categoriesList: PropTypes.arrayOf(PropTypes.shape({})),
  moduleClassName: PropTypes.string,
  bgClass: PropTypes.string,
  bgColor: PropTypes.string,
  isHomePage: PropTypes.bool,
  icidParam: PropTypes.string,
  variation: PropTypes.string,
  linkedImage: PropTypes.arrayOf(PropTypes.shape({})),
  disableVideosForAppleDevice: PropTypes.bool,
};

ModuleTabbedCarousel.defaultProps = {
  isHpNewModuleDesignEnabled: false,
  moduleClassName: '',
  headerText: [],
  carouselTabs: [],
  categoriesList: [],
  bgClass: '',
  bgColor: '',
  isHomePage: false,
  icidParam: '',
  variation: 'cms',
  linkedImage: [],
  disableVideosForAppleDevice: false,
};

ModuleTabbedCarousel.displayName = 'ModuleTabbedCarousel';

export default SafeComponent(ModuleTabbedCarousel);
export { ModuleTabbedCarousel as ModuleTabbedCarouselVanilla };
